// extracted by mini-css-extract-plugin
module.exports = {"appName":"NavbarAppItem_appName__xCiv1"};